import React, { useEffect, useState } from "react";
import "./ReplayZone.scss";
import sizeMe from "react-sizeme";

import {
  AspectRatio,
  Cards,
  assets,
  isDevReact,
  ReplayerMode
} from "../api/ReplayVariables";
import ReplayPlayerWindow from "./ReplayPlayerWindow";
import SpaceKoPanel from "./SpaceKoPanel";
import { buyInValue } from "../api/SpaceKoToken";
import { Button } from "react-bootstrap";
import PotLabel from "./PotLabel";
import DealerLabel from "./DealerLabel";
import { getRepositionedSeat } from "../api/ReplayPlayer";
import { useTranslation } from "react-i18next";
import {
  ArrowDown,
  ArrowLeft,
  ArrowRight,
  ArrowUp,
  ArrowUpRightSquareFill,
  Keyboard
} from "react-bootstrap-icons";
import PlayerWindowPositions from "../api/PlayerWindowPositions";
import HoldupLabel from "./HoldupLabel";

function ReplayZone({
  hand,
  action,
  mainSeat,
  preferredSeat,
  size,
  fontSize,
  mode,
  bbMode,
  streetPots,
  anonymous,
  showAllCards,
  table,
  showShortcuts,
  customShortcuts = [],
  onStats,
  onBBModeChanged
})
{
  const [counter, setCounter] = useState(0);
  const [imgPosition, setImgPosition] = useState({ top: 0, left: 0 });
  const [winamaxNav, setWinamaxNav] = useState(localStorage.getItem("winamaxNav")==="true");
	 
  const winamaxNavChanged = () => {
    localStorage.setItem("winamaxNav", !winamaxNav);
    setWinamaxNav(!winamaxNav);
    window.dispatchEvent(new Event("storage"));
  }

  const tableRatio = AspectRatio.refWidth / AspectRatio.refHeight;
  let realTableRatio = 1;

  let tableWidth = size.width;
  let tableHeight = size.height;
  let tableX = 0;
  let tableY = 0;
  //  if (fullScreen) {
  if (size.width >= size.height) {
    //console.log("full, width", size);
    tableHeight = size.height;
    tableWidth = size.height * tableRatio;
    if (tableWidth > size.width) {
      tableWidth = size.width;
      tableHeight = tableWidth / tableRatio;
    }
    realTableRatio = tableWidth / AspectRatio.refWidth;
  } else {
    //console.log("full, height", size);
    tableWidth = size.width;
    tableHeight = tableWidth / tableRatio;
    if (tableHeight > size.height) {
      tableHeight = size.height;
      tableWidth = tableHeight * tableRatio;
    }
    realTableRatio = tableHeight / AspectRatio.refHeight;
  }
  tableX = (size.width - tableWidth) / 2;
  tableY = (size.height - tableHeight) / 2;
  //  } else {
  //    //console.log("not full", size);
  //    tableWidth = size.width;
  //    tableHeight = AspectRatio.refHeight * ratio;
  //    realTableRatio = tableWidth / AspectRatio.refWidth;
  //  }

  const chipsBorderWidth =
    AspectRatio.refChipsBorderWidth * realTableRatio + "px";
  const cardWidth = AspectRatio.refCardHalfWidth * realTableRatio + "px";
  const cardHeight =
    AspectRatio.refCardHalfWidth *
      AspectRatio.refCardHalfHeightRatio *
      realTableRatio +
    "px";
  const boardCardWidth = AspectRatio.refBoardCardWidth * realTableRatio + "px";
  const boardCardMargin = AspectRatio.refBoardCardMargin * realTableRatio;
  const cardQuarterWidth =
    AspectRatio.refCardQuarterWidth * realTableRatio + "px";

  const printPositions = () => {
    let output = "";
    Object.keys(PlayerWindowPositions).forEach((key) => {
      var value = PlayerWindowPositions[key];
      output +=
        'PlayerWindowPositions["' +
        key +
        '"] = ' +
        (isNaN(value) ? '"' + value + '"' : value) +
        ";\n";
    });
    console.log(output);
  };

  const buttonSeat = getRepositionedSeat(
    hand.buttonSeat,
    hand.nbSeats,
    preferredSeat,
    mainSeat
  );

  //console.log("img", imgPosition)
  //console.log("size", size)

  let buttonTop = imgPosition.top;
  buttonTop -= size.position.top;
  buttonTop += PlayerWindowPositions[hand.nbSeats + "_" + buttonSeat + "_buttonTop"] * realTableRatio;
  
  const buttonLeft =
    imgPosition.left -
    size.position.left +
    PlayerWindowPositions[hand.nbSeats + "_" + buttonSeat + "_buttonLeft"] *
      realTableRatio;

  const { t } = useTranslation();

  

  //--------------
  //EFFECT
  //--------------
  useEffect(() => {
    let img = document.getElementById("table");
    setImgPosition(img.getBoundingClientRect());
    return () => {};
  }, [hand, size, bbMode, anonymous]);

  //--------------
  //CONTENT
  //--------------
  // v2-1379 : le coeur serialise la specialite par son nom, pas par son identifiant.
  // Hors Space KO les deux valeurs restent neutres et rien ne change a l'affichage.
  const spaceKo = hand.gameSpecialty === "SPACE_KO_TYPE";
  const spaceKoBuyIn = spaceKo ? buyInValue(hand) : 0;
  const heroPlayer = spaceKo
    ? action.players.find((player) => player.pseudo === hand.hero)
    : undefined;

  // v2-1291: in Xeester, the keys of the replayer shortcuts set in its options. A page key the user kept shows as
  // before, one replaced shows its new keys, one cleared is not listed, and the actions the page has no key for get a
  // line when they have one. On Opencards the list is empty: the page's own keys.
  const keysOf = (id, pageKeys) => {
    const shortcut = customShortcuts.find((s) => s.id === id);
    return !shortcut || shortcut.legacy ? pageKeys : shortcut.keys;
  };
  const pageRows = [
    { id: "REPLAYER_PREVIOUS_ACTION", label: t("actionbar.previousAction"), keys: winamaxNav ? <ArrowLeft></ArrowLeft> : <ArrowDown></ArrowDown> },
    { id: "REPLAYER_NEXT_ACTION", label: t("actionbar.nextAction"), keys: winamaxNav ? <ArrowRight></ArrowRight> : <ArrowUp></ArrowUp> },
    { id: "REPLAYER_PREVIOUS_HAND", label: t("actionbar.previousHand"), keys: winamaxNav ? <ArrowDown></ArrowDown> : <ArrowLeft></ArrowLeft>, software: true },
    { id: "REPLAYER_NEXT_HAND", label: t("actionbar.nextHand"), keys: winamaxNav ? <ArrowUp></ArrowUp> : <ArrowRight></ArrowRight>, software: true },
    { id: "REPLAYER_PLAY_STOP", label: t("actionbar.play") + "/" + t("actionbar.stop"), keys: t("actionbar.spacebar") },
    { id: "REPLAYER_SPEED", label: t("actionbar.speed"), keys: "s" },
    { id: "REPLAYER_TIMELINE", label: t("actionbar.timeline"), keys: "t" },
    { id: "REPLAYER_SOUNDS", label: t("actionbar.sounds_mute") + "/" + t("actionbar.sounds_unmute"), keys: "m" }
  ];
  const shortcutRows = pageRows
    .filter((row) => !row.software || mode === ReplayerMode.SOFTWARE)
    .map((row) => ({ id: row.id, label: row.label, keys: keysOf(row.id, row.keys) }))
    .concat(customShortcuts.filter((s) => !pageRows.some((row) => row.id === s.id)))
    .filter((row) => row.keys);

  return (
    <>
    <div className={"replay-zone h-100 w-100 " + hand.gameVariant}>
      <style
        dangerouslySetInnerHTML={{
          __html:
            `
    .pseudo div{
      border-top-width : ` +
            chipsBorderWidth +
            ` !important;
    }
    .player .bounty{
      border-width : ` +
            chipsBorderWidth +
            ` !important;
    }
    .chips{
      border-bottom-width : ` +
            chipsBorderWidth +
            ` !important;
    }
    .cardHalf{
      width : ` +
            cardWidth +
            `; 
      height : ` +
            cardHeight +
            `; 
            
    }
    .cardQuarter{
      width : ` +
            cardQuarterWidth +
            `; 
      height : ` +
            cardHeight +
            `; 
    }

    .cards2 .cardHalf:first-child{
          margin-right : ` +
            boardCardMargin +
            `px !important;
    }

    .board img{
      width : ` +
            boardCardWidth +
            `; 
            margin : auto ` +
            boardCardMargin +
            `px;
    }
      .board4, .board5{
            margin-left : ` +
            boardCardMargin * 4 +
            `px !important;
      } 


`
        }}
      ></style>
      {isDevReact() ? (
        <Button className="print" onClick={printPositions}>
          print
        </Button>
      ) : (
        <></>
      )}

      <table
        id="shortcuts"
        style={{
          visibility: showShortcuts ? "visible" : "hidden",
          fontSize: fontSize + "px"
        }}
      >
        <tbody>
          <tr>
            <td colSpan="2">&nbsp;</td>
          </tr>
          <tr>
            <td
              colSpan="2"
              className="d-flex flex-row align-items-center"
              style={{
                fontSize: fontSize * 1.2 + "px"
              }}
            >
              &nbsp;&nbsp;
              <Keyboard
                style={{
                  fontSize: fontSize * 1.5 + "px"
                }}
              ></Keyboard>
              &nbsp;&nbsp;{t("shortcuts")}&nbsp;&nbsp;
            </td>
          </tr>
<tr>
            <td colSpan="2">&nbsp;&nbsp;<input type="checkbox" onChange={winamaxNavChanged} checked={winamaxNav}  name="winamax"/><label htmlFor="winamax" onClick={winamaxNavChanged}>{t("actionbar.winamaxNav")}</label></td>
          </tr>
          {shortcutRows.map((row) => (
            <tr key={row.id}>
              <td>&nbsp;&nbsp;{row.label}&nbsp;&nbsp;</td>
              <td>&nbsp;&nbsp;{row.keys}&nbsp;&nbsp;</td>
            </tr>
          ))}
          <tr>
            <td colSpan="2" height="100%"></td>
          </tr>
        </tbody>
      </table>
      <img
        id="table"
        src={assets["table" + table]}
        alt="poker table"
        width={tableWidth}
        height={tableHeight}
        style={{ top: tableY + "px", left: tableX + "px" }}
      />
      <div className="board d-flex w-100 h-100 justify-content-center align-middle">
        {action.cards.map((card, index) => {
          if (card > 0)
            return (
              <img
                key={"board" + index}
                className={"board" + (index + 1)}
                src={Cards["card" + card]}
                alt=""
              />
            );
          else
            return (
              <img
                key={"board" + index}
                className={"board" + (index + 1)}
                src={Cards["cardEmpty"]}
                alt=""
              />
            );
        })}
      </div>

      <PotLabel
        zoneSize={size}
        action={action}
        realTableRatio={realTableRatio}
        bigBlind={hand.bigBlind}
        bbMode={bbMode}
        streetPots={streetPots}
      ></PotLabel>
      <HoldupLabel
        zoneSize={size}
        realTableRatio={realTableRatio}
        smallBlind={hand.smallBlind}
        bigBlind={hand.bigBlind}
        ante={hand.ante}
        holdUp={hand.holdupAmount}
        bbMode={bbMode}
        level={hand.level}
        levelLabel={t("level")}
      ></HoldupLabel>
      <DealerLabel
        seats={hand.nbSeats}
        seat={buttonSeat}
        realTableRatio={realTableRatio}
        top={buttonTop}
        left={buttonLeft}
        onMove={() => setCounter(counter + 1)}
      ></DealerLabel>

      {action.players.map((player) => {
        let top =
          imgPosition.top -
          size.position.top +
          PlayerWindowPositions[
            hand.nbSeats +
              "_" +
              getRepositionedSeat(
                player.seat,
                hand.nbSeats,
                preferredSeat,
                mainSeat
              ) +
              "_top"
          ] *
            realTableRatio;
        let left =
          imgPosition.left -
          size.position.left +
          PlayerWindowPositions[
            hand.nbSeats +
              "_" +
              getRepositionedSeat(
                player.seat,
                hand.nbSeats,
                preferredSeat,
                mainSeat
              ) +
              "_left"
          ] *
          realTableRatio;
        if (hand.statistics[player.pseudo])
        {
          return (
            <ReplayPlayerWindow
              className="player"
              key={"player" + player.seat}
              seats={hand.nbSeats}
              player={player}
              stats={hand.statistics[player.pseudo]}
              hero={hand.hero}
              mainSeat={mainSeat}
              preferredSeat={preferredSeat}
              top={top}
              left={left}
              imgPosition={imgPosition}
              zonePosition={size.position}
              realTableRatio={realTableRatio}
              bigBlind={hand.bigBlind}
              potSize={action.potSize}
              bbMode={bbMode}
              spaceKo={spaceKo}
              buyIn={spaceKoBuyIn}
              anonymous={anonymous}
              showAllCards={showAllCards}
              onMove={() => setCounter(counter + 1)}
              onBBModeChanged={() =>
              {
                onBBModeChanged();
              }}

            ></ReplayPlayerWindow>
          );
        } else return (
            <ReplayPlayerWindow
              className="player"
              key={"player" + player.seat}
              seats={hand.nbSeats}
              player={player}
              stats={hand.statistics[player.pseudo]}
              hero={hand.hero}
              mainSeat={mainSeat}
              preferredSeat={preferredSeat}
              top={top}
              left={left}
              imgPosition={imgPosition}
              zonePosition={size.position}
              realTableRatio={realTableRatio}
              bigBlind={hand.bigBlind}
              potSize={action.potSize}
              bbMode={bbMode}
              spaceKo={spaceKo}
              buyIn={spaceKoBuyIn}
              anonymous={anonymous}
              showAllCards={showAllCards}
              onMove={() => setCounter(counter + 1)}
              onBBModeChanged={() =>
              {
                onBBModeChanged();
              }}

            ></ReplayPlayerWindow>          
        );
      })}
      {heroPlayer ? (
        <SpaceKoPanel
          bounty={heroPlayer.bounty}
          buyIn={spaceKoBuyIn}
          currency={hand.currency}
          realTableRatio={realTableRatio}
        ></SpaceKoPanel>
      ) : (
        <></>
      )}
      <Button
        className="powered"
        onClick={() => {
          window.open(window.serverUrl+"", "_blank");
        }}
        style={{
          fontSize: fontSize + "px",
          display:
            mode === ReplayerMode.SOFTWARE ||
            mode === ReplayerMode.APP ||
            mode === ReplayerMode.APP_STANDALONE
              ? "none"
              : "inline"
        }}
      >
        {t("powered")}&nbsp;
        <ArrowUpRightSquareFill></ArrowUpRightSquareFill>&nbsp;&nbsp;
      </Button>
    </div>
    </>
  );
}

export default sizeMe({
  monitorHeight: true,
  monitorWidth: true,
  monitorPosition: true
})(ReplayZone);
